﻿/*
@license textAngular
Author : Austin Anderson
License : 2013 MIT
Version 1.5.0

See README.md or https://github.com/fraywing/textAngular/wiki for requirements and use.
*/
// tests against the current jqLite/jquery implementation if this can be an element
function validElementString(string) {
    try {
        return angular.element(string).length !== 0;
    } catch (any) {
        return false;
    }
}
// setup the global contstant functions for setting up the toolbar

// all tool definitions
window.taTools = {};
// wa: add replacementTags
var replacementTags = {
    video: {
        youtube: {
            player: 'https://www.youtube.com/embed/',
            type: 'youtu',
            getThumbnailUrl: function (id) {
                return 'https://img.youtube.com/vi/' + id + '/hqdefault.jpg';
            },
            getImgSrc: function (link) {
                var svg = encodeURIComponent('<svg width="500" height="281" viewBox="0 0 500 281" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
                    '<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="500" height="281">' +
                    '<rect width="500" height="281" rx="4" fill="black"/>' +
                    '</mask>' +
                    '<g mask="url(#mask0)">' +
                    '<rect width="500" height="281"/>' +
                    '</g>' +
                    '<path d="M0 4C0 1.79086 1.79086 0 4 0H496C498.209 0 500 1.79086 500 4V100H0V4Z" fill="url(#paint0_linear)"/>' +
                    '<path d="M0 181H500V277C500 279.209 498.209 281 496 281H4.00001C1.79087 281 0 279.209 0 277V181Z" fill="url(#paint1_linear)"/>' +
                    '<text fill="white" xml:space="preserve" style="white-space: pre" font-family="Roboto, sans-serif" font-size="14" letter-spacing="0.014em"><tspan x="16" y="28.9883">' + link + '</tspan></text>' +
                    '<g clip-path="url(#clip0)">' +
                    '<path d="M58.9836 239.426C58.5246 237.721 57.1803 236.377 55.4754 235.918C52.3607 235.066 39.9016 235.066 39.9016 235.066C39.9016 235.066 27.4426 235.066 24.3279 235.885C22.6557 236.344 21.2787 237.721 20.8197 239.426C20 242.541 20 249 20 249C20 249 20 255.492 20.8197 258.574C21.2787 260.279 22.623 261.623 24.3279 262.082C27.4754 262.934 39.9016 262.934 39.9016 262.934C39.9016 262.934 52.3607 262.934 55.4754 262.115C57.1803 261.656 58.5246 260.311 58.9836 258.607C59.8033 255.492 59.8033 249.033 59.8033 249.033C59.8033 249.033 59.8361 242.541 58.9836 239.426Z" fill="#FF0000"/>' +
                    '<path d="M35.9344 254.967L46.2951 249L35.9344 243.033V254.967Z" fill="white"/>' +
                    '</g>' +
                    ' <defs>' +
                    '<linearGradient id="paint0_linear" x1="250" y1="0" x2="250" y2="100" gradientUnits="userSpaceOnUse">' +
                    '<stop stop-opacity="0.7"/>' +
                    '<stop offset="0.325967" stop-opacity="0.35"/>' +
                    '<stop offset="0.679558" stop-opacity="0.1"/>' +
                    '<stop offset="1" stop-opacity="0"/>' +
                    '</linearGradient>' +
                    '<linearGradient id="paint1_linear" x1="250" y1="181" x2="250" y2="281" gradientUnits="userSpaceOnUse">' +
                    '<stop stop-opacity="0"/>' +
                    '<stop offset="0.325967" stop-opacity="0.1"/>' +
                    '<stop offset="0.679558" stop-opacity="0.35"/>' +
                    '<stop offset="1" stop-opacity="0.7"/>' +
                    '</linearGradient>' +
                    '<clipPath id="clip0">' +
                    '<rect width="40" height="27.8689" fill="white" transform="translate(20 235.066)"/>' +
                    '</clipPath>' +
                    '</defs>' +
                    ' </svg>');
                return 'data:image/svg+xml;utf8,' + svg;
            }
        },
        vimeo: {
            type: 'vimeo',
            player: 'https://player.vimeo.com/video/',
            getThumbnailUrl: function (id) {
                return 'http://vimeo.com/api/v2/video/' + id + '.json'
            },
            getImgSrc: function (link) {
                var svg = encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="281" viewBox="0 0 500 281" fill="none">' +
                    '<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="500" height="281">' +
                    '<rect width="500" height="281" rx="4" fill="black"/>' +
                    '</mask>' +
                    '<g mask="url(#mask0)">' +
                    '<rect width="500" height="281.41" fill="url(#pattern0)"/>' +
                    '</g>' +
                    '<path d="M0 4C0 1.79086 1.79086 0 4 0H496C498.209 0 500 1.79086 500 4V100H0V4Z" fill="url(#paint0_linear)"/>' +
                    '<path d="M0 181H500V277C500 279.209 498.209 281 496 281H4.00001C1.79087 281 0 279.209 0 277V181Z" fill="url(#paint1_linear)"/>' +
                    '<text fill="white" xml:space="preserve" style="white-space: pre" font-family="Roboto, sans-serif" font-size="14" letter-spacing="0.014em"><tspan x="16" y="28.9883">' + link + '</tspan></text>' +
                    '<path d="M60 257C60 259.2 58.2 261 56 261H24C21.8 261 20 259.2 20 257V225C20 222.8 21.8 221 24 221H56C58.2 221 60 222.8 60 225V257Z" fill="#1AB7EA"/>' +
                    '<path d="M53.6666 234.3C53.5333 237.1 51.5666 240.967 47.7666 245.867C43.8333 250.967 40.4999 253.533 37.7999 253.533C36.0999 253.533 34.6999 251.967 33.5333 248.867C32.7666 246 31.9666 243.167 31.1999 240.3C30.3333 237.2 29.3999 235.633 28.3999 235.633C28.1999 235.633 27.4333 236.1 26.1333 237L24.7666 235.233C26.1999 233.967 27.5999 232.733 28.9999 231.467C30.8999 229.833 32.3333 228.967 33.2999 228.867C35.5333 228.667 36.9333 230.2 37.4666 233.467C38.0333 237.033 38.4333 239.233 38.6333 240.1C39.2666 243.033 39.9999 244.533 40.7666 244.533C41.3666 244.533 42.2666 243.567 43.4999 241.667C44.6999 239.767 45.3666 238.3 45.4333 237.3C45.5999 235.667 44.9666 234.833 43.4999 234.833C42.7999 234.833 42.0999 235 41.3666 235.3C42.7999 230.633 45.4999 228.4 49.4999 228.533C52.4333 228.6 53.8333 230.533 53.6666 234.3Z" fill="white"/>' +
                    '<defs>' +
                    '<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">' +
                    '<use xlink:href="#image0" transform="scale(0.000641026 0.00113895)"/>' +
                    '</pattern>' +
                    '<linearGradient id="paint0_linear" x1="250" y1="0" x2="250" y2="100" gradientUnits="userSpaceOnUse">' +
                    '<stop stop-opacity="0.7"/>' +
                    '<stop offset="0.325967" stop-opacity="0.35"/>' +
                    '<stop offset="0.679558" stop-opacity="0.1"/>' +
                    '<stop offset="1" stop-opacity="0"/>' +
                    '</linearGradient>' +
                    '<linearGradient id="paint1_linear" x1="250" y1="181" x2="250" y2="281" gradientUnits="userSpaceOnUse">' +
                    '<stop stop-opacity="0"/>' +
                    '<stop offset="0.325967" stop-opacity="0.1"/>' +
                    '<stop offset="0.679558" stop-opacity="0.35"/>' +
                    '<stop offset="1" stop-opacity="0.7"/>' +
                    '</linearGradient>' +
                    '</defs>' +
                    '</svg>');
                return 'data:image/svg+xml;utf8,' + svg;
            }
        },
        class: 'ta-insert-video',
        regex: /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/,
        widthRegex: /width=("|')(\d{2,3})('|")/,
        heightRegex: /height=("|')(\d{2,3})('|")/,
        height: 160,
        width: 320,
        attr: 'ta-insert-video',
        attrImgSrc: 'img-src',
        getEmbed: function (svg, src, thumbnai) {
            return '<img class="wysiwyg__thumbnail ' + this.class + '" width="100%"  src="' + svg + '" ' + this.attr + '="' + src + '" ' + this.attrImgSrc + '="' + thumbnai + '" frameborder="0"  style="background: url(\'' + thumbnai + '\');" />'
        }
    },
    twitter: {
        img: 'assets/images/social-media/twitter_icon.png',
        height: 160,
        width: 160,
        script: 'https://platform.twitter.com/widgets.js',
        regex: /http(?:s)?:\/\/(?:www\.)?twitter\.com\/([a-zA-Z0-9_]+)\/status\/([a-zA-Z0-9_]+)/g,
        class: 'twitter-tweet',
        attr: 'ta-insert-twitter',
        getImgSrc: function (link) {
            var svg = encodeURIComponent('<svg width="500" height="113" viewBox="0 0 500 113" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<rect width="500" height="113" rx="4" fill="#FAF9FC"/>' +
                '<rect x="0.5" y="0.5" width="499" height="112" rx="3.5" stroke="black" stroke-opacity="0.06"/>' +
                '<path d="M270 27.8488C268.528 28.5007 266.947 28.942 265.286 29.1401C266.981 28.1246 268.282 26.5161 268.895 24.5999C267.309 25.5401 265.554 26.2247 263.683 26.5907C262.188 24.9967 260.056 24 257.695 24C253.163 24 249.488 27.6733 249.488 32.2072C249.488 32.8504 249.562 33.4735 249.7 34.0752C242.877 33.733 236.833 30.4677 232.783 25.5019C232.078 26.7155 231.674 28.1246 231.674 29.6265C231.674 32.4743 233.123 34.9873 235.324 36.4591C233.979 36.4152 232.714 36.0466 231.607 35.4311C231.606 35.4662 231.606 35.5 231.606 35.5333C231.606 39.5106 234.435 42.8284 238.19 43.5819C237.501 43.7687 236.776 43.8684 236.028 43.8684C235.498 43.8684 234.983 43.8195 234.483 43.7242C235.528 46.9838 238.558 49.3564 242.149 49.4222C239.34 51.6224 235.8 52.9356 231.957 52.9356C231.296 52.9356 230.643 52.898 230 52.8203C233.632 55.1503 237.946 56.5074 242.579 56.5074C257.675 56.5074 265.929 44.0019 265.929 33.1575C265.929 32.8034 265.921 32.4473 265.905 32.0963C267.508 30.9385 268.9 29.4949 269.999 27.8501L270 27.8488Z" fill="#1DA1F2"/>' +
                '<text fill="#1DA1F2" xml:space="preserve" style="white-space: pre" font-family="Roboto, sans-serif" font-size="14" letter-spacing="0.014em"><tspan x="53.0755" y="92.9883">' + link + '</tspan></text>' +
                '</svg>');
            return 'data:image/svg+xml;utf8,' + svg;
        }
    },
    instagram: {
        img: 'assets/images/social-media/instagram_icon.png',
        height: 160,
        width: 160,
        script: 'https://www.instagram.com/embed.js',
        regex: /http(?:s)?:\/\/(?:www\.)?instagram\.com\/p\/([a-zA-Z0-9_]+)/g,
        class: 'instagram-media',
        attr: 'ta-insert-instagram',
        getImgSrc: function (link) {
            var svg = encodeURIComponent('<svg width="500" height="113" viewBox="0 0 500 113" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' +
                '<rect width="500" height="113" rx="4" fill="#FAF9FC"/>' +
                '<rect x="0.5" y="0.5" width="499" height="112" rx="3.5" stroke="black" stroke-opacity="0.06"/>' +
                '<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="230" y="20" width="40" height="40">' +
                '<path d="M250 23.6036C255.34 23.6036 255.973 23.624 258.082 23.7202C260.032 23.8092 261.091 24.135 261.795 24.4088C262.729 24.7716 263.395 25.2051 264.095 25.9049C264.795 26.6048 265.228 27.271 265.591 28.2046C265.865 28.9093 266.191 29.9683 266.28 31.9183C266.376 34.0272 266.396 34.6598 266.396 40C266.396 45.3402 266.376 45.9728 266.28 48.0817C266.191 50.0317 265.865 51.0907 265.591 51.7954C265.228 52.729 264.795 53.3952 264.095 54.095C263.395 54.7949 262.729 55.2284 261.795 55.5911C261.091 55.865 260.032 56.1908 258.082 56.2798C255.973 56.376 255.341 56.3964 250 56.3964C244.659 56.3964 244.027 56.376 241.918 56.2798C239.968 56.1908 238.909 55.865 238.205 55.5911C237.271 55.2284 236.605 54.7949 235.905 54.0951C235.205 53.3952 234.772 52.729 234.409 51.7954C234.135 51.0907 233.809 50.0317 233.72 48.0817C233.624 45.9728 233.604 45.3402 233.604 40C233.604 34.6598 233.624 34.0272 233.72 31.9183C233.809 29.9683 234.135 28.9093 234.409 28.2046C234.772 27.271 235.205 26.6048 235.905 25.905C236.605 25.2051 237.271 24.7716 238.205 24.4088C238.909 24.135 239.968 23.8092 241.918 23.7202C244.027 23.624 244.66 23.6036 250 23.6036ZM250 20C244.568 20 243.887 20.023 241.754 20.1203C239.625 20.2175 238.171 20.5556 236.899 21.05C235.584 21.5611 234.469 22.2449 233.357 23.3568C232.245 24.4687 231.561 25.5841 231.05 26.8992C230.556 28.1714 230.217 29.6252 230.12 31.754C230.023 33.8872 230 34.5683 230 40C230 45.4317 230.023 46.1128 230.12 48.246C230.217 50.3748 230.556 51.8286 231.05 53.1008C231.561 54.4159 232.245 55.5313 233.357 56.6432C234.469 57.7551 235.584 58.4389 236.899 58.95C238.171 59.4444 239.625 59.7825 241.754 59.8797C243.887 59.977 244.568 60 250 60C255.432 60 256.113 59.977 258.246 59.8797C260.375 59.7825 261.829 59.4444 263.101 58.95C264.416 58.4389 265.531 57.7551 266.643 56.6432C267.755 55.5313 268.439 54.4159 268.95 53.1008C269.444 51.8286 269.783 50.3748 269.88 48.246C269.977 46.1128 270 45.4317 270 40C270 34.5683 269.977 33.8872 269.88 31.754C269.783 29.6252 269.444 28.1714 268.95 26.8992C268.439 25.5841 267.755 24.4687 266.643 23.3568C265.531 22.2449 264.416 21.5611 263.101 21.05C261.829 20.5556 260.375 20.2175 258.246 20.1203C256.113 20.023 255.432 20 250 20Z" fill="black"/>' +
                '<path d="M250 29.7297C244.328 29.7297 239.73 34.3279 239.73 40C239.73 45.6721 244.328 50.2703 250 50.2703C255.672 50.2703 260.27 45.6721 260.27 40C260.27 34.3279 255.672 29.7297 250 29.7297ZM250 46.6667C246.318 46.6667 243.333 43.6819 243.333 40C243.333 36.3181 246.318 33.3333 250 33.3333C253.682 33.3333 256.667 36.3181 256.667 40C256.667 43.6819 253.682 46.6667 250 46.6667Z" fill="black"/>' +
                '<path d="M260.676 31.724C262.002 31.724 263.076 30.6495 263.076 29.324C263.076 27.9985 262.002 26.924 260.676 26.924C259.351 26.924 258.276 27.9985 258.276 29.324C258.276 30.6495 259.351 31.724 260.676 31.724Z" fill="black"/>' +
                '</mask>' +
                '<g mask="url(#mask0)">' +
                '<rect x="230" y="20" width="40" height="40" fill="url(#pattern0)"/>' +
                '</g>' +
                '<text fill="#DB2D75" xml:space="preserve" style="white-space: pre" font-family="Roboto, sans-serif" font-size="14" letter-spacing="0.014em"><tspan x="104.553" y="92.9883">' + link + '</tspan></text>' +
                '<defs>' +
                '<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">' +
                '<use xlink:href="#image0" transform="scale(0.0125)"/>' +
                '</pattern>' +
                '<image id="image0" width="80" height="80" xlink:href="data:image/png;base64,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"/>' +
                '</defs>' +
                '</svg>');
            return 'data:image/svg+xml;utf8,' + svg;
        }
    },
    carousel: {
        attr: 'ta-insert-carousel',
        class: 'slick-carousel',
        script: {
            slick: '/scripts/vendor/slick/slick.min.js',
            jquery: '/scripts/vendor/slick/jquery.js',
            start: '/scripts/vendor/slick/carousel.start.js',
        },
        stylesheet: '/scripts/vendor/slick/slick.css',
        getImgSrc: function (count) {
            var msg = count + (count > 1 ? ' images' : ' image');
            var svg = encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="500" height="312" viewBox="0 0 500 312" fill="none">' +
                '<mask id="a" maskUnits="userSpaceOnUse" x="0" y="0" width="500" height="312">' +
                '<rect width="500" height="312" rx="4" fill="#000"/>' +
                '</mask>' +
                '<g mask="url(#a)">' +
                '<path fill="url(#pattern0)" d="M0 0h500v312H0z"/>' +
                '</g>' +
                '<path d="M0 4a4 4 0 0 1 4-4h492a4 4 0 0 1 4 4v96H0V4z" fill="url(#paint0_linear)"/>' +
                '<path d="M38 28V16c0-1.1-.9-2-2-2H24c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L32 23l4 5H24l3-4zm-9-6v14c0 1.1.9 2 2 2h14v-2H20V18h-2z" fill="#fff" opacity=".87"/>' +
                ' <text fill="#fff" font-family="Roboto" font-size="14" letter-spacing=".014em" white-space="pre">' +
                '<tspan x="48" y="28.988">' + msg + '</tspan>' +
                '</text>' +
                '<defs>' +
                '<pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">' +
                '<use xlink:href="#image0" transform="matrix(.0004 0 0 .00063 0 0)"/>' +
                '</pattern>' +
                '<linearGradient id="paint0_linear" x1="250" x2="250" y2="100" gradientUnits="userSpaceOnUse">' +
                '<stop stop-opacity=".7"/>' +
                '<stop offset=".326" stop-opacity=".35"/>' +
                '<stop offset=".68" stop-opacity=".1"/>' +
                '<stop offset="1" stop-opacity="0"/>' +
                '</linearGradient>' +
                '</defs>' +
                '</svg>');
            return 'data:image/svg+xml;utf8,' + svg;
        }
    }

}

/*  A tool definition is an object with the following key/value parameters:
		action: [function(deferred, restoreSelection)]
				a function that is executed on clicking on the button - this will allways be executed using ng-click and will
				overwrite any ng-click value in the display attribute.
				The function is passed a deferred object ($q.defer()), if this is wanted to be used `return false;` from the action and
				manually call `deferred.resolve();` elsewhere to notify the editor that the action has finished.
				restoreSelection is only defined if the rangy library is included and it can be called as `restoreSelection()` to restore the users
				selection in the WYSIWYG editor.
		display: [string]?
				Optional, an HTML element to be displayed as the button. The `scope` of the button is the tool definition object with some additional functions
				If set this will cause buttontext and iconclass to be ignored
		class: [string]?
				Optional, if set will override the taOptions.classes.toolbarButton class.
		buttontext: [string]?
				if this is defined it will replace the contents of the element contained in the `display` element
		iconclass: [string]?
				if this is defined an icon (<i>) will be appended to the `display` element with this string as it's class
		tooltiptext: [string]?
				Optional, a plain text description of the action, used for the title attribute of the action button in the toolbar by default.
		activestate: [function(commonElement)]?
				this function is called on every caret movement, if it returns true then the class taOptions.classes.toolbarButtonActive
				will be applied to the `display` element, else the class will be removed
		disabled: [function()]?
				if this function returns true then the tool will have the class taOptions.classes.disabled applied to it, else it will be removed
	Other functions available on the scope are:
		name: [string]
				the name of the tool, this is the first parameter passed into taRegisterTool
		isDisabled: [function()]
				returns true if the tool is disabled, false if it isn't
		displayActiveToolClass: [function(boolean)]
				returns true if the tool is 'active' in the currently focussed toolbar
		onElementSelect: [Object]
				This object contains the following key/value pairs and is used to trigger the ta-element-select event
				element: [String]
					an element name, will only trigger the onElementSelect action if the tagName of the element matches this string
				filter: [function(element)]?
					an optional filter that returns a boolean, if true it will trigger the onElementSelect.
				action: [function(event, element, editorScope)]
					the action that should be executed if the onElementSelect function runs */
// name and toolDefinition to add into the tools available to be added on the toolbar
function registerTextAngularTool(name, toolDefinition) {
    if (!name || name === '' || taTools.hasOwnProperty(name)) throw ('textAngular Error: A unique name is required for a Tool Definition');
    if (
        (toolDefinition.display && (toolDefinition.display === '' || !validElementString(toolDefinition.display))) ||
        (!toolDefinition.display && !toolDefinition.buttontext && !toolDefinition.iconclass)
    )
        throw ('textAngular Error: Tool Definition for "' + name + '" does not have a valid display/iconclass/buttontext value');
    taTools[name] = toolDefinition;
}

angular.module('textAngularSetup', [])
    .constant('taRegisterTool', registerTextAngularTool)
    .value('taTools', taTools)
    // Here we set up the global display defaults, to set your own use a angular $provider#decorator.
    .value('taOptions', {
        //////////////////////////////////////////////////////////////////////////////////////
        // forceTextAngularSanitize
        // set false to allow the textAngular-sanitize provider to be replaced
        // with angular-sanitize or a custom provider.
        forceTextAngularSanitize: true,
        ///////////////////////////////////////////////////////////////////////////////////////
        // keyMappings
        // allow customizable keyMappings for specialized key boards or languages
        //
        // keyMappings provides key mappings that are attached to a given commandKeyCode.
        // To modify a specific keyboard binding, simply provide function which returns true
        // for the event you wish to map to.
        // Or to disable a specific keyboard binding, provide a function which returns false.
        // Note: 'RedoKey' and 'UndoKey' are internally bound to the redo and undo functionality.
        // At present, the following commandKeyCodes are in use:
        // 98, 'TabKey', 'ShiftTabKey', 105, 117, 'UndoKey', 'RedoKey'
        //
        // To map to an new commandKeyCode, add a new key mapping such as:
        // {commandKeyCode: 'CustomKey', testForKey: function (event) {
        //  if (event.keyCode=57 && event.ctrlKey && !event.shiftKey && !event.altKey) return true;
        // } }
        // to the keyMappings. This example maps ctrl+9 to 'CustomKey'
        // Then where taRegisterTool(...) is called, add a commandKeyCode: 'CustomKey' and your
        // tool will be bound to ctrl+9.
        //
        // To disble one of the already bound commandKeyCodes such as 'RedoKey' or 'UndoKey' add:
        // {commandKeyCode: 'RedoKey', testForKey: function (event) { return false; } },
        // {commandKeyCode: 'UndoKey', testForKey: function (event) { return false; } },
        // to disable them.
        //
        keyMappings: [],
        toolbar: [
            ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
            ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
            ['html', 'insertImage', 'insertLink', 'wordcount', 'charcount']
        ],
        classes: {
            focussed: "focussed",
            toolbar: "btn-toolbar",
            toolbarGroup: "btn-group",
            toolbarButton: "btn btn-default",
            toolbarButtonActive: "active",
            disabled: "disabled",
            textEditor: 'form-control',
            htmlEditor: 'form-control'
        },
        defaultTagAttributes: {
            a: { target: "" }
        },
        setup: {
            // wysiwyg mode
            textEditorSetup: function ($element) { /* Do some processing here */ },
            // raw html
            htmlEditorSetup: function ($element) { /* Do some processing here */ }
        },
        defaultFileDropHandler:
            /* istanbul ignore next: untestable image processing */
            function (file, insertAction) {
                var reader = new FileReader();
                if (file.type.substring(0, 5) === 'image') {
                    reader.onload = function () {
                        if (reader.result !== '') insertAction('insertImage', reader.result, true);
                    };

                    reader.readAsDataURL(file);
                    // NOTE: For async procedures return a promise and resolve it when the editor should update the model.
                    return true;
                }
                return false;
            },
        // wa: add imageComponent
        externalComponent: {
            insertImage: null,
            removeImage: null,
            carousel: null,
            dataSource: null,
            allowCustomSelect: false
        },
        adaptHtml: function (html) {
            html = html.replace(/<font [^\>]*>/g, '').replace(/<\/font>/g, '').replace(/<span [^\>]*>/g, '<span>');
            var addTags = [];
            if (replacementTags.instagram.regex.test(html)) {
                addTags.push('<script async src="' + replacementTags.instagram.script + '"></script>');
            }
            if (replacementTags.twitter.regex.test(html)) {
                addTags.push('<script async src="' + replacementTags.twitter.script + '"></script>');
            }
            var carousel = $('<div>' + html + '</div>').find('.slick-carousel');
            if (carousel && carousel.length > 0) {
                var exCarousel = this.externalComponent.dataSource ? this.externalComponent.dataSource.carousel : null;
                html = '<link rel="stylesheet" type="text/css" href="' + (exCarousel ? exCarousel.stylesheet : replacementTags.carousel.stylesheet) + '"/>' + html;
                addTags.push('<script  src="' + (exCarousel ? exCarousel.script.jquery : replacementTags.carousel.script.jquery) + '"></script>')
                addTags.push('<script src="' + (exCarousel ? exCarousel.script.slick : replacementTags.carousel.script.slick) + '"></script>');
                addTags.push('<script src="' + (exCarousel ? exCarousel.script.start : replacementTags.carousel.script.start) + '"></script>');
            }
            html += addTags.join('');
            return html;
        },
        // wa: add sanitize bind html
        taSanitizeBind: function (inputData) {
            if (inputData) {
                var html = $('<div>' + inputData + '</div>');
                var iframes = html.find("iframe");
                this.sanitizeBind.iframe(iframes);
                var blockquotes = html.find("blockquote");
                this.sanitizeBind.blockquote(blockquotes);
                var carousel = html.find('div.' + replacementTags.carousel.class);
                this.sanitizeBind.carousel(carousel);
                return html[0].innerHTML;
            } else return '';
        },
        // wa: add  sanitizeBind Iframe/Blockquote/carousel
        sanitizeBind: {
            iframe: function (iframes) {
                if (!iframes || iframes.length == 0) {
                    return;
                }
                var videoData = replacementTags.video;
                angular.forEach(iframes,
                    function (_frame) {
                        var element = $(_frame);
                        var match = element.attr('src').match(videoData.regex);
                        if (!match || !match[3]) { return; }
                        var video;
                        if (match[3].indexOf(videoData.youtube.type) > -1) {
                            video = replacementTags.video.youtube;
                        } else if (match[3].indexOf(videoData.vimeo.type) > -1) {
                            video = replacementTags.video.vimeo;
                        }
                        if (!video) {
                            return;
                        }
                        var id = match[6] ? match[6]: '';
                        var svg = video.getImgSrc(video.player + id);
                        var embed = replacementTags.video.getEmbed(svg, element.attr('src'), element.attr(replacementTags.video.attrImgSrc));
                        element.replaceWith(angular.element(embed))
                    });
            },

            blockquote: function (blockquotes) {
                if (!blockquotes || blockquotes.length == 0) {
                    return;
                }
                var tweet = replacementTags.twitter;
                var instagram = replacementTags.instagram;
                angular.forEach(blockquotes,
                    function (_blockquote) {
                        var element = $(_blockquote);
                        var tag = null;
                        if (element.hasClass(tweet.class)) {
                            tag = tweet;
                        } else if (element.hasClass(instagram.class)) {
                            tag = instagram;
                        }
                        if (tag == null) {
                            return;
                        }
                        var anchors = element.find("a");
                        angular.forEach(anchors, function (anchor) {
                            var attributes = $(anchor).prop("attributes");
                            var match = attributes["href"].value.match(tag.regex);
                            if (match) {
                                var embed = '<img class="' + tag.class + '" ' + tag.attr + '="' + match[0] + '" src="' + tag.getImgSrc(match[0]) + '" />';
                                element.replaceWith(embed);
                            }
                        });
                    });
            },

            getCarouselHtmlItem: function (item) {
                if (!item) return null;
                var container = $(item);
                if (!container.hasClass(replacementTags.carousel.class)) {
                    return null;
                }
                var images = container.find('img');
                var imagesData = [];
                angular.forEach(images, function (img) {
                    var attributes = $(img).prop("attributes");
                    var src = attributes["src"].value;
                    if (src) {
                        imagesData.push(src);
                    }
                });
                if (imagesData.length == 0) {
                    return null;
                }
                return '<img class="wysiwyg__thumbnail ' + replacementTags.carousel.class + '" ' + replacementTags.carousel.attr + '="' + imagesData.join(";") + '" src="' + replacementTags.carousel.getImgSrc(imagesData.length) + '"   style="background: url(\'' + imagesData[0] + '\');" />';
            },
            carousel: function (containers) {
                if (!containers || containers.length == 0) {
                    return;
                }
                var self = this;
                angular.forEach(containers, function (item) {
                    var img = self.getCarouselHtmlItem(item);
                    if (img) {
                        $(item).replaceWith(img);
                    }
                });
            }
        }
    })

    // This is the element selector string that is used to catch click events within a taBind, prevents the default and $emits a 'ta-element-select' event
    // these are individually used in an angular.element().find() call. What can go here depends on whether you have full jQuery loaded or just jQLite with angularjs.
    // div is only used as div.ta-insert-video caught in filter.
    .value('taSelectableElements', ['a', 'img'])

    // This is an array of objects with the following options:
    //				selector: <string> a jqLite or jQuery selector string
    //				customAttribute: <string> an attribute to search for
    //				renderLogic: <function(element)>
    // Both or one of selector and customAttribute must be defined.
    .value('taCustomRenderers', [
        {
            // wa: To correct video element. For now  support youtube  and vimeo
            selector: 'img',
            customAttribute: replacementTags.video.attr,
            renderLogic: function (element) {
                var iframe = angular.element('<iframe></iframe>');
                var attributes = element.prop("attributes");
                // loop through element attributes and apply them on iframe

                /*  angular.forEach(attributes, function (attr) {
                    if(attr.name != 'style')
                    iframe.attr(attr.name, attr.value);
                });  */
                iframe.attr('img-src', element.attr(replacementTags.video.attrImgSrc))
                iframe.attr('src', element.attr(replacementTags.video.attr));
                iframe.attr('class', replacementTags.video.class);
                element.replaceWith(iframe);
            },
        }, {
            // wa: To correct tweet element.
            selector: 'img',
            customAttribute: replacementTags.twitter.attr,
            renderLogic: function (element) {
                var tag = replacementTags.twitter;
                var attributes = element.prop("attributes");
                var href = attributes[tag.attr];
                if (href) {
                    var blockquote = angular.element('<blockquote class="' + tag.class + '"><a href="' + href.value + '" ></a></blockquote>');
                    element.replaceWith(blockquote);
                    setTimeout(function () {
                        if (window.twttr) {
                            window.twttr.widgets.load();
                        } else {
                            $.getScript(tag.script, function () {
                                if (window.twttr)
                                    window.twttr.widgets.load();
                            });
                        }
                    });
                }
            }
        }, {
            // wa: To correct instagram element.
            selector: 'img',
            customAttribute: replacementTags.instagram.attr,
            renderLogic: function (element) {
                var tag = replacementTags.instagram;
                var attributes = element.prop("attributes");
                var href = attributes[tag.attr];
                if (href) {
                    var blockquote = angular.element('<blockquote class="' + tag.class + '"><a href="' + href.value + '" ></a></blockquote>');
                    element.replaceWith(blockquote);
                    setTimeout(function () {
                        if (window.instgrm) {
                            window.instgrm.Embeds.process();
                        } else {
                            $.getScript(tag.script, function () {
                                if (window.instgrm)
                                    window.instgrm.Embeds.process();
                            });
                        }

                    });
                }
            }
        }, {
            // wa: To correct carousel element.
            selector: 'img',
            customAttribute: replacementTags.carousel.attr,
            renderLogic: function (element) {
                var tag = replacementTags.carousel;
                var attributes = element.prop("attributes");

                var dataAttr = attributes[tag.attr];
                if (!dataAttr) {
                    return;
                }
                var images = [];
                var items = dataAttr.value.split(';')
                if (!items) {
                    return;
                }

                angular.forEach(items, function (item) {
                    if (item && item.trim()) {
                        images.push('<img  src="' + item.trim() + '" />');
                    }
                });
                if (images.length > 0) {
                    var container = angular.element('<div style="visibility: hidden;" class="' + tag.class + '">' + images.join('') + '</div>');
                    element.replaceWith(container);
                    var css = $('link[href="' + tag.stylesheet + '"]');

                    if (css.length == 0) {
                        $('head').append('<link rel="stylesheet" type="text/css" href="' + tag.stylesheet + '"/>');
                    }
                    setTimeout(function () {
                        if (typeof $.fn.slick === 'undefined') {
                            $.getScript(tag.script.slick, slickStart);
                        } else {
                            slickStart();
                        }
                    }, 100);
                }
                function slickStart() {
                    var el = $('div.slick-carousel:not(.slick-initialized)');
                    $(el).on('init', function (slick) {
                        $(el).css('visibility', 'visible');
                    }).slick({
                        fade: true,
                        dots: true,
                        arrows: false
                    });
                }
            }
        }
    ])

    .value('taTranslations', {
        // moved to sub-elements
        //toggleHTML: "Toggle HTML",
        //insertImage: "Please enter a image URL to insert",
        //insertLink: "Please enter a URL to insert",
        //insertVideo: "Please enter a youtube URL to embed",
        html: {
            tooltip: 'Toggle html / Rich Text'
        },
        // tooltip for heading - might be worth splitting
        heading: {
            tooltip: 'Heading '
        },
        p: {
            tooltip: 'Paragraph'
        },
        pre: {
            tooltip: 'Preformatted text'
        },
        ul: {
            tooltip: 'Unordered List'
        },
        ol: {
            tooltip: 'Ordered List'
        },
        quote: {
            tooltip: 'Quote/unquote selection or paragraph'
        },
        undo: {
            tooltip: 'Undo'
        },
        redo: {
            tooltip: 'Redo'
        },
        bold: {
            tooltip: 'Bold'
        },
        italic: {
            tooltip: 'Italic'
        },
        underline: {
            tooltip: 'Underline'
        },
        strikeThrough: {
            tooltip: 'Strikethrough'
        },
        justifyLeft: {
            tooltip: 'Align text left'
        },
        justifyRight: {
            tooltip: 'Align text right'
        },
        justifyFull: {
            tooltip: 'Justify text'
        },
        justifyCenter: {
            tooltip: 'Center'
        },
        indent: {
            tooltip: 'Increase indent'
        },
        outdent: {
            tooltip: 'Decrease indent'
        },
        clear: {
            tooltip: 'Clear formatting'
        },
        insertImage: {
            dialogPrompt: 'Please enter an image URL to insert',
            tooltip: 'Insert image',
            hotkey: 'the - possibly language dependent hotkey ... for some future implementation'
        },
        insertVideo: {
            tooltip: 'Insert video',
            dialogPrompt: 'Please enter a youtube or a vimeo URL to embed'
        },
        insertLink: {
            tooltip: 'Insert / edit link',
            dialogPrompt: "Please enter a URL to insert"
        },
        editLink: {
            reLinkButton: {
                tooltip: "Relink"
            },
            unLinkButton: {
                tooltip: "Unlink"
            },
            targetToggle: {
                buttontext: "Open in New Window"
            }
        },
        wordcount: {
            tooltip: 'Display words Count'
        },
        charcount: {
            tooltip: 'Display characters Count'
        },
        insertTweet: {
            tooltip: 'Insert tweet',
            dialogPrompt: 'Please enter a tweet URL to embed'
        },
        insertInstagram: {
            tooltip: 'Insert post of instagram',
            dialogPrompt: 'Please enter a post URL to embed'
        },
        insertCarousel: {
            tooltip: 'Insert carousel',

        }
    }
    )
    .factory('taToolFunctions', ['$window', 'taTranslations', 'taOptions', function ($window, taTranslations, taOptions) {

        var _eventName = {
            select: 'ta-element-select',
            mouseover: 'ta-element-mouseover',
        }
        function _showPopoverCustom(editorScope, $element, editFunction, classBtn) {
            editorScope.displayElements.popoverCustom.css('width', '100px');
            var containerCustom = editorScope.displayElements.popoverContainerCustom;
            containerCustom.empty();

            var buttonGroup = angular.element('<div class="btn-group">');

            var edit = angular.element('<button type="button" class="btn wysiwyg__edit-btns p0 ' + (classBtn ? classBtn : '') + '" unselectable="on" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M11 25.25V29h3.75l11.06-11.06-3.75-3.75L11 25.25zm17.71-10.21a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" fill="#000"/></svg></button>');
            var remove = angular.element('<button type="button" class="btn wysiwyg__edit-btns p0 ml8 ' + (classBtn ? classBtn : '') + ' unselectable="on" tabindex="-1">  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M14 27c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V15H14v12zm13-15h-3.5l-1-1h-5l-1 1H13v2h14v-2z" fill="#000"/></svg></button>');
            buttonGroup.append(edit);
            buttonGroup.append(remove);

            containerCustom.append(buttonGroup);
            remove.on('click', function (event) {
                event.preventDefault();
                $element.remove();
                editorScope.updateTaBindtaTextElement();
                editorScope.hidePopoverCustom();
            });
            edit.on('click', function (event) {

                event.preventDefault();
                if (editFunction) {
                    editFunction();
                }
            });
            editorScope.showPopoverCustom($element);
        }

        function _imgOnSelectAction(event, $element, editorScope) {
            // setup the editor toolbar
            // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
            var finishEdit = function () {
                editorScope.updateTaBindtaTextElement();
                editorScope.hidePopover();
            };
            event.preventDefault();
            editorScope.displayElements.popover.css('width', '249px');  //375
            var container = editorScope.displayElements.popoverContainer;
            container.empty();
            var buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
            var fullButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">100% </button>');
            fullButton.on('click', function (event) {
                event.preventDefault();
                $element.css({
                    'width': '100%',
                    'height': ''
                });
                finishEdit();
            });
            var halfButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">50% </button>');
            halfButton.on('click', function (event) {
                event.preventDefault();
                $element.css({
                    'width': '50%',
                    'height': ''
                });
                finishEdit();
            });
            var quartButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">25% </button>');
            quartButton.on('click', function (event) {
                event.preventDefault();
                $element.css({
                    'width': '25%',
                    'height': ''
                });
                finishEdit();
            });
            var resetButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1">Reset</button>');
            resetButton.on('click', function (event) {
                event.preventDefault();
                $element.css({
                    width: '',
                    height: ''
                });
                finishEdit();
            });
            buttonGroup.append(fullButton);
            buttonGroup.append(halfButton);
            buttonGroup.append(quartButton);
            buttonGroup.append(resetButton);
            container.append(buttonGroup);
             // don't use
            //buttonGroup = angular.element('<div class="btn-group" style="padding-right: 6px;">');
            //var floatLeft = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-left"></i></button>');
            //floatLeft.on('click', function (event) {
            //    event.preventDefault();
            //    // webkit
            //    $element.css('float', 'left');
            //    // firefox
            //    $element.css('cssFloat', 'left');
            //    // IE < 8
            //    $element.css('styleFloat', 'left');
            //    finishEdit();
            //});
            //var floatRight = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-right"></i></button>');
            //floatRight.on('click', function (event) {
            //    event.preventDefault();
            //    // webkit
            //    $element.css('float', 'right');
            //    // firefox
            //    $element.css('cssFloat', 'right');
            //    // IE < 8
            //    $element.css('styleFloat', 'right');
            //    finishEdit();
            //});
            //var floatNone = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-align-justify"></i></button>');
            //floatNone.on('click', function (event) {
            //    event.preventDefault();
            //    // webkit
            //    $element.css('float', '');
            //    // firefox
            //    $element.css('cssFloat', '');
            //    // IE < 8
            //    $element.css('styleFloat', '');
            //    finishEdit();
            //});
            //buttonGroup.append(floatLeft);
            //buttonGroup.append(floatNone);
            //buttonGroup.append(floatRight);
            //container.append(buttonGroup);

            buttonGroup = angular.element('<div class="btn-group">');
            var remove = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');
            remove.on('click', function (event) {
                event.preventDefault();
                var _element = $element.get(0);
                $element.remove();
                if (taOptions.externalComponent.removeImage && _element instanceof HTMLImageElement) {
                    taOptions.externalComponent.removeImage(_element)
                }
                finishEdit();
            });
            buttonGroup.append(remove);
            container.append(buttonGroup);

            editorScope.showPopover($element);
            editorScope.showResizeOverlay($element);
        }

        function _extractVideo(value) {
            var deferred = $.Deferred();
            if (!value) return null;
            // - Supported YouTube URL formats:
            //   - http://www.youtube.com/watch?v=My2FRPA3Gf8
            //   - http://youtu.be/My2FRPA3Gf8
            //   - https://youtube.googleapis.com/v/My2FRPA3Gf8
            // - Supported Vimeo URL formats:
            //   - http://vimeo.com/25451551
            //   - http://player.vimeo.com/video/25451551
            // - Also supports relative URLs:
            //   - //player.vimeo.com/video/25451551

            var videoData = replacementTags.video;
            var match = value.match(videoData.regex);
            if (!match) return null;
            var type, url;
            if (match[3].indexOf(videoData.youtube.type) > -1) {
                type = videoData.youtube.type;
                url = videoData.youtube.player + match[6];
            } else if (match[3].indexOf(videoData.vimeo.type) > -1) {
                type = videoData.vimeo.type;
                url = videoData.vimeo.player + match[6];
            }
            var matchWidth = value.match(videoData.widthRegex);
            var matchHeight = value.match(videoData.heightRegex);
            if (type && url) {
                var videoObj = {
                    type: type,
                    id: match[6],
                    embedUrl: url,
                    thumbnail: null,
                    size: matchWidth && matchHeight && matchWidth[2] && matchHeight[2]
                        ? {
                            width: matchWidth[2],
                            height: matchHeight[2]
                        }
                        : {
                            width: videoData.width,
                            height: videoData.height
                        },
                    svg: ''
                };

                if (videoObj.type == videoData.youtube.type) {
                    videoObj.thumbnail = videoData.youtube.getThumbnailUrl(videoObj.id);
                    videoObj.svg = replacementTags.video.youtube.getImgSrc(videoObj.embedUrl);
                    var embed = replacementTags.video.getEmbed(videoObj.svg, videoObj.embedUrl, videoObj.thumbnail);
                    deferred.resolve(embed);
                } else if (videoObj.type == videoData.vimeo.type) {
                    // Requires jQuery
                    $.get(videoData.vimeo.getThumbnailUrl(videoObj.id),
                        function (data) {
                            videoObj.thumbnail = data[0].thumbnail_large;
                            videoObj.svg = replacementTags.video.vimeo.getImgSrc(videoObj.embedUrl);
                            var embed = replacementTags.video.getEmbed(videoObj.svg, videoObj.embedUrl, videoObj.thumbnail);
                            deferred.resolve(embed);
                        });
                }
            } else {
                return deferred.resolve(null);
            }

            return deferred.promise();
        }

        function _getEmbedForTweetOrIstagram(value, tag) {
            if (!value || !tag)
                return '';
            var match = value.match(tag.regex);
            if (match) {
                var embed = '<img class="' + tag.class + '" ' + tag.attr + '="' + match[0] + '" src="' + tag.getImgSrc(match[0]) + '" />';
                /*  embed += '<script async src="' + tag.script + '" charset="utf-8"></script>'; */
                return embed;
            }
            return '';
        }
        return {
            imgOnSelectActionShortFunctionality: function (event, $element, editorScope) {
                // setup the editor toolbar
                // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic/display
                var finishEdit = function () {
                    editorScope.updateTaBindtaTextElement();
                    editorScope.hidePopover();
                };
                event.preventDefault();

                editorScope.displayElements.popover.css('width', '63px');
                var container = editorScope.displayElements.popoverContainer;
                container.empty();
                var buttonGroup = angular.element('<div class="btn-group">');

                var remove = angular.element('<button type="button" class="btn btn-default btn-sm btn-small" unselectable="on" tabindex="-1"><i class="fa fa-trash-o"></i></button>');
                remove.on('click', function (event) {
                    event.preventDefault();
                    $element.remove();
                });
                buttonGroup.append(remove);
                container.append(buttonGroup);

                editorScope.showPopover($element);

            },
            aOnSelectAction: function (event, $element, editorScope) {
                if (event.name !== _eventName.select) {
                    event.preventDefault();
                    return;
                }
                // setup the editor toolbar
                // Credit to the work at http://hackerwins.github.io/summernote/ for this editbar logic
                event.preventDefault();
                editorScope.displayElements.popover.css('width', '466px');
                var container = editorScope.displayElements.popoverContainer;
                container.empty();
                container.css('line-height', '28px');
                var link = angular.element('<a href="' + $element.attr('href') + '" target="_blank">' + $element.attr('href') + '</a>');
                link.css({
                    'display': 'inline-block',
                    'max-width': '200px',
                    'overflow': 'hidden',
                    'text-overflow': 'ellipsis',
                    'white-space': 'nowrap',
                    'vertical-align': 'middle'
                });
                container.append(link);
                var buttonGroup = angular.element('<div class="btn-group pull-right">');
                var reLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small wd-auto wysiwyg-btn--standart" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.reLinkButton.tooltip + '"><i class="fa fa-edit icon-edit"></i></button>');
                reLinkButton.on('click', function (event) {
                    event.preventDefault();
                    var urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, $element.attr('href'));
                    if (urlLink && urlLink !== '' && urlLink !== 'http://') {
                        $element.attr('href', urlLink);
                        editorScope.updateTaBindtaTextElement();
                    }
                    editorScope.hidePopover();
                });
                buttonGroup.append(reLinkButton);
                var unLinkButton = angular.element('<button type="button" class="btn btn-default btn-sm btn-small wd-auto wysiwyg-btn--standart" tabindex="-1" unselectable="on" title="' + taTranslations.editLink.unLinkButton.tooltip + '"><i class="fa fa-unlink icon-unlink"></i></button>');
                // directly before this click event is fired a digest is fired off whereby the reference to $element is orphaned off
                unLinkButton.on('click', function (event) {
                    event.preventDefault();
                    $element.replaceWith($element.contents());
                    editorScope.updateTaBindtaTextElement();
                    editorScope.hidePopover();
                });
                buttonGroup.append(unLinkButton);
                var targetToggle = angular.element('<button type="button" class="btn btn-default btn-sm btn-small wd-auto wysiwyg-btn--standart" tabindex="-1" unselectable="on">' + taTranslations.editLink.targetToggle.buttontext + '</button>');
                if ($element.attr('target') === '_blank') {
                    targetToggle.addClass('active');
                }
                targetToggle.on('click', function (event) {
                    event.preventDefault();
                    $element.attr('target', ($element.attr('target') === '_blank') ? '' : '_blank');
                    targetToggle.toggleClass('active');
                    editorScope.updateTaBindtaTextElement();
                });
                buttonGroup.append(targetToggle);
                container.append(buttonGroup);
                editorScope.showPopover($element);
            },
            extractYoutubeVideoId: function (url) {
                var re = /(?:youtube(?:-nocookie)?\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/i;
                var match = url.match(re);
                return (match && match[1]) || null;
            },
            // wa: add extractVideo return obj
            extractVideo: _extractVideo,
            // wa: add getEmbedForTweetOrIstagram returm embed as string
            getEmbedForTweetOrIstagram: _getEmbedForTweetOrIstagram,
            // wa: custom imageonSelect
            imgOnSelectAction: function (event, $element, editorScope) {
                if ((taOptions.externalComponent.allowCustomSelect && event.name == _eventName.select) ||
                    (!taOptions.externalComponent.allowCustomSelect && event.name == _eventName.mouseover)) {
                    return;
                }

                if (taOptions.externalComponent.allowCustomSelect) {
                    _showPopoverCustom(editorScope, $element, function () {
                        taOptions.externalComponent.insertImage().then(function (html) {
                            if (html) {
                                $element.replaceWith(html);
                            }
                        }).catch(function () { }).finally(function () {
                            editorScope.updateTaBindtaTextElement();
                            editorScope.hidePopoverCustom();
                        });

                    }, 'light-icon');

                } else {
                    _imgOnSelectAction(event, $element, editorScope);
                }
            },
            // wa:  onSelect carousel
            carouselOnSelectAction: function (event, $element, editorScope) {

                if ((taOptions.externalComponent.allowCustomSelect && event.name == _eventName.select) ||
                    (!taOptions.externalComponent.allowCustomSelect && event.name == _eventName.mouseover)) {
                    return;
                }
                if (taOptions.externalComponent.allowCustomSelect) {
                    _showPopoverCustom(editorScope, $element, function () {
                        if (taOptions.externalComponent.carousel) {
                            var attributes = $element.prop("attributes");
                            var dataAttr = attributes[replacementTags.carousel.attr];
                            if (!dataAttr) {
                                return;
                            }
                            var images = [];
                            var items = dataAttr.value.split(';')
                            angular.forEach(items, function (item) {
                                if (item && item.trim()) {
                                    images.push(item.trim());
                                }
                            });

                            taOptions.externalComponent.carousel(images).then(function (urls) {
                                if (urls.length == 0) {
                                    $element.remove();
                                    return;
                                }
                                var images = '';
                                angular.forEach(urls, function (url) {
                                    images += '<img src="' + url + '" />';
                                })
                                var embed = '<div class="slick-carousel">' + images + '</div>';
                                var html = taOptions.sanitizeBind.getCarouselHtmlItem(embed);
                                $element.replaceWith(html);
                            }).catch(function () { }).finally(function () {
                                editorScope.updateTaBindtaTextElement();
                                editorScope.hidePopoverCustom();
                            });
                        }
                    }, 'light-icon');
                } else {
                    _imgOnSelectAction(event, $element, editorScope);
                }
            },
            videoOnSelectAction: function (event, $element, editorScope) {
                if ((taOptions.externalComponent.allowCustomSelect && event.name == _eventName.select) ||
                    (!taOptions.externalComponent.allowCustomSelect && event.name == _eventName.mouseover)) {
                    return;
                }

                if (taOptions.externalComponent.allowCustomSelect) {
                    _showPopoverCustom(editorScope, $element, function () {
                        var attributes = $element.prop("attributes");
                        var url = attributes[replacementTags.video.attr];

                        var holder = url ? url.value : 'https:// or Embed code';
                        var valuePrompt = $window.prompt(taTranslations.insertVideo.dialogPrompt, holder);
                        if (valuePrompt && valuePrompt !== '' && valuePrompt !== holder) {

                            _extractVideo(valuePrompt).then(function (embed) {
                                if (embed) {
                                    $element.replaceWith(embed);
                                }
                                editorScope.updateTaBindtaTextElement();
                                editorScope.hidePopoverCustom();
                            }).catch(function () {

                                editorScope.hidePopoverCustom();
                            });

                        }
                    }, 'light-icon');

                } else {
                    _imgOnSelectAction(event, $element, editorScope);
                }
            },
            socialMediaOnSelectAction: function (event, $element, editorScope) {
                if ((taOptions.externalComponent.allowCustomSelect && event.name == _eventName.select) ||
                    (!taOptions.externalComponent.allowCustomSelect && event.name == _eventName.mouseover)) {
                    return;
                }

                if (taOptions.externalComponent.allowCustomSelect) {
                    _showPopoverCustom(editorScope, $element, function () {
                        var attributes = $element.prop("attributes");
                        var url = attributes[replacementTags.instagram.attr] || attributes[replacementTags.twitter.attr];

                        var holder = url ? url.value : 'https:// or Embed code';
                        var valuePrompt = $window.prompt('Please enter a post URL to embed', holder);
                        if (valuePrompt && valuePrompt !== '' && valuePrompt !== holder) {

                            var embed = _getEmbedForTweetOrIstagram(valuePrompt, replacementTags.instagram);
                            embed = embed ? embed : _getEmbedForTweetOrIstagram(valuePrompt, replacementTags.twitter);
                            if (embed) {
                                $element.replaceWith(embed);
                            }

                            editorScope.updateTaBindtaTextElement();
                            editorScope.hidePopoverCustom();
                        }
                    });

                } else {
                    _imgOnSelectAction(event, $element, editorScope);
                }
            }
        };
    }])
    .run(['taRegisterTool', '$q', '$window', 'taTranslations', 'taSelection', 'taToolFunctions', '$sanitize', 'taOptions', function (taRegisterTool, $q, $window, taTranslations, taSelection, taToolFunctions, $sanitize, taOptions) {
        // test for the version of $sanitize that is in use
        // You can disable this check by setting taOptions.textAngularSanitize == false
        var gv = {}; $sanitize('', gv);
        /* istanbul ignore next, throws error */
        if ((taOptions.forceTextAngularSanitize === true) && (gv.version !== 'taSanitize')) {
            throw angular.$$minErr('textAngular')("textAngularSetup", "The textAngular-sanitize provider has been replaced by another -- have you included angular-sanitize by mistake?");
        }
        taRegisterTool("html", {
            iconclass: 'fa fa-code',
            tooltiptext: taTranslations.html.tooltip,
            action: function () {
                this.$editor().switchView();
            },
            activeState: function () {
                return this.$editor().showHtml;
            }
        });
        // add the Header tools
        // convenience functions so that the loop works correctly
        var _retActiveStateFunction = function (q) {
            return function () { return this.$editor().queryFormatBlockState(q); };
        };
        var headerAction = function () {
            return this.$editor().wrapSelection("formatBlock", "<" + this.name.toUpperCase() + ">");
        };
        angular.forEach(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'], function (h) {
            taRegisterTool(h.toLowerCase(), {
                buttontext: h.toUpperCase(),
                tooltiptext: taTranslations.heading.tooltip + h.charAt(1),
                action: headerAction,
                activeState: _retActiveStateFunction(h.toLowerCase())
            });
        });
        taRegisterTool('p', {
            buttontext: 'P',
            tooltiptext: taTranslations.p.tooltip,
            action: function () {
                return this.$editor().wrapSelection("formatBlock", "<P>");
            },
            activeState: function () { return this.$editor().queryFormatBlockState('p'); }
        });
        // key: pre -> taTranslations[key].tooltip, taTranslations[key].buttontext
        taRegisterTool('pre', {
            buttontext: 'pre',
            tooltiptext: taTranslations.pre.tooltip,
            action: function () {
                return this.$editor().wrapSelection("formatBlock", "<PRE>");
            },
            activeState: function () { return this.$editor().queryFormatBlockState('pre'); }
        });
        taRegisterTool('ul', {
            iconclass: 'fa fa-list-ul',
            tooltiptext: taTranslations.ul.tooltip,
            action: function () {
                return this.$editor().wrapSelection("insertUnorderedList", null);
            },
            activeState: function () { return this.$editor().queryCommandState('insertUnorderedList'); }
        });
        taRegisterTool('ol', {
            iconclass: 'fa fa-list-ol',
            tooltiptext: taTranslations.ol.tooltip,
            action: function () {
                return this.$editor().wrapSelection("insertOrderedList", null);
            },
            activeState: function () { return this.$editor().queryCommandState('insertOrderedList'); }
        });
        taRegisterTool('quote', {
            iconclass: 'fa fa-quote-right',
            tooltiptext: taTranslations.quote.tooltip,
            action: function () {
                return this.$editor().wrapSelection("formatBlock", "<BLOCKQUOTE>");
            },
            activeState: function () { return this.$editor().queryFormatBlockState('blockquote'); }
        });
        taRegisterTool('undo', {
            iconclass: 'fa fa-undo',
            tooltiptext: taTranslations.undo.tooltip,
            action: function () {
                return this.$editor().wrapSelection("undo", null);
            }
        });
        taRegisterTool('redo', {
            iconclass: 'fa fa-repeat',
            tooltiptext: taTranslations.redo.tooltip,
            action: function () {
                return this.$editor().wrapSelection("redo", null);
            }
        });
        taRegisterTool('bold', {
            iconclass: 'fa fa-bold',
            tooltiptext: taTranslations.bold.tooltip,
            action: function () {
                return this.$editor().wrapSelection("bold", null);
            },
            activeState: function () {
                return this.$editor().queryCommandState('bold');
            },
            commandKeyCode: 98
        });
        taRegisterTool('justifyLeft', {
            iconclass: 'fa fa-align-left',
            tooltiptext: taTranslations.justifyLeft.tooltip,
            action: function () {
                return this.$editor().wrapSelection("justifyLeft", null);
            },
            activeState: function (commonElement) {
                /* istanbul ignore next: */
                if (commonElement && commonElement.nodeName === '#document') return false;
                var result = false;
                if (commonElement)
                    result =
                        commonElement.css('text-align') === 'left' ||
                        commonElement.attr('align') === 'left' ||
                        (
                            commonElement.css('text-align') !== 'right' &&
                            commonElement.css('text-align') !== 'center' &&
                            commonElement.css('text-align') !== 'justify' && !this.$editor().queryCommandState('justifyRight') && !this.$editor().queryCommandState('justifyCenter')
                        ) && !this.$editor().queryCommandState('justifyFull');
                result = result || this.$editor().queryCommandState('justifyLeft');
                return result;
            }
        });
        taRegisterTool('justifyRight', {
            iconclass: 'fa fa-align-right',
            tooltiptext: taTranslations.justifyRight.tooltip,
            action: function () {
                return this.$editor().wrapSelection("justifyRight", null);
            },
            activeState: function (commonElement) {
                /* istanbul ignore next: */
                if (commonElement && commonElement.nodeName === '#document') return false;
                var result = false;
                if (commonElement) result = commonElement.css('text-align') === 'right';
                result = result || this.$editor().queryCommandState('justifyRight');
                return result;
            }
        });
        taRegisterTool('justifyFull', {
            iconclass: 'fa fa-align-justify',
            tooltiptext: taTranslations.justifyFull.tooltip,
            action: function () {
                return this.$editor().wrapSelection("justifyFull", null);
            },
            activeState: function (commonElement) {
                var result = false;
                if (commonElement) result = commonElement.css('text-align') === 'justify';
                result = result || this.$editor().queryCommandState('justifyFull');
                return result;
            }
        });
        taRegisterTool('justifyCenter', {
            iconclass: 'fa fa-align-center',
            tooltiptext: taTranslations.justifyCenter.tooltip,
            action: function () {
                return this.$editor().wrapSelection("justifyCenter", null);
            },
            activeState: function (commonElement) {
                /* istanbul ignore next: */
                if (commonElement && commonElement.nodeName === '#document') return false;
                var result = false;
                if (commonElement) result = commonElement.css('text-align') === 'center';
                result = result || this.$editor().queryCommandState('justifyCenter');
                return result;
            }
        });
        taRegisterTool('indent', {
            iconclass: 'fa fa-indent',
            tooltiptext: taTranslations.indent.tooltip,
            action: function () {
                return this.$editor().wrapSelection("indent", null);
            },
            activeState: function () {
                return this.$editor().queryFormatBlockState('blockquote');
            },
            commandKeyCode: 'TabKey'
        });
        taRegisterTool('outdent', {
            iconclass: 'fa fa-outdent',
            tooltiptext: taTranslations.outdent.tooltip,
            action: function () {
                return this.$editor().wrapSelection("outdent", null);
            },
            activeState: function () {
                return false;
            },
            commandKeyCode: 'ShiftTabKey'
        });
        taRegisterTool('italics', {
            iconclass: 'fa fa-italic',
            tooltiptext: taTranslations.italic.tooltip,
            action: function () {
                return this.$editor().wrapSelection("italic", null);
            },
            activeState: function () {
                return this.$editor().queryCommandState('italic');
            },
            commandKeyCode: 105
        });
        taRegisterTool('underline', {
            iconclass: 'fa fa-underline',
            tooltiptext: taTranslations.underline.tooltip,
            action: function () {
                return this.$editor().wrapSelection("underline", null);
            },
            activeState: function () {
                return this.$editor().queryCommandState('underline');
            },
            commandKeyCode: 117
        });
        taRegisterTool('strikeThrough', {
            iconclass: 'fa fa-strikethrough',
            tooltiptext: taTranslations.strikeThrough.tooltip,
            action: function () {
                return this.$editor().wrapSelection("strikeThrough", null);
            },
            activeState: function () {
                return document.queryCommandState('strikeThrough');
            }
        });
        taRegisterTool('clear', {
            iconclass: 'fa fa-ban',
            tooltiptext: taTranslations.clear.tooltip,
            action: function (deferred, restoreSelection) {
                var i;
                this.$editor().wrapSelection("removeFormat", null);
                var possibleNodes = angular.element(taSelection.getSelectionElement());
                // remove lists
                var removeListElements = function (list) {
                    list = angular.element(list);
                    var prevElement = list;
                    angular.forEach(list.children(), function (liElem) {
                        var newElem = angular.element('<p></p>');
                        newElem.html(angular.element(liElem).html());
                        prevElement.after(newElem);
                        prevElement = newElem;
                    });
                    list.remove();
                };
                angular.forEach(possibleNodes.find("ul"), removeListElements);
                angular.forEach(possibleNodes.find("ol"), removeListElements);
                if (possibleNodes[0].tagName.toLowerCase() === 'li') {
                    var _list = possibleNodes[0].parentNode.childNodes;
                    var _preLis = [], _postLis = [], _found = false;
                    for (i = 0; i < _list.length; i++) {
                        if (_list[i] === possibleNodes[0]) {
                            _found = true;
                        } else if (!_found) _preLis.push(_list[i]);
                        else _postLis.push(_list[i]);
                    }
                    var _parent = angular.element(possibleNodes[0].parentNode);
                    var newElem = angular.element('<p></p>');
                    newElem.html(angular.element(possibleNodes[0]).html());
                    if (_preLis.length === 0 || _postLis.length === 0) {
                        if (_postLis.length === 0) _parent.after(newElem);
                        else _parent[0].parentNode.insertBefore(newElem[0], _parent[0]);

                        if (_preLis.length === 0 && _postLis.length === 0) _parent.remove();
                        else angular.element(possibleNodes[0]).remove();
                    } else {
                        var _firstList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
                        var _secondList = angular.element('<' + _parent[0].tagName + '></' + _parent[0].tagName + '>');
                        for (i = 0; i < _preLis.length; i++) _firstList.append(angular.element(_preLis[i]));
                        for (i = 0; i < _postLis.length; i++) _secondList.append(angular.element(_postLis[i]));
                        _parent.after(_secondList);
                        _parent.after(newElem);
                        _parent.after(_firstList);
                        _parent.remove();
                    }
                    taSelection.setSelectionToElementEnd(newElem[0]);
                }
                // clear out all class attributes. These do not seem to be cleared via removeFormat
                var $editor = this.$editor();
                var recursiveRemoveClass = function (node) {
                    node = angular.element(node);
                    if (node[0] !== $editor.displayElements.text[0]) node.removeAttr('class');
                    angular.forEach(node.children(), recursiveRemoveClass);
                };
                angular.forEach(possibleNodes, recursiveRemoveClass);
                // check if in list. If not in list then use formatBlock option
                if (possibleNodes[0].tagName.toLowerCase() !== 'li' &&
                    possibleNodes[0].tagName.toLowerCase() !== 'ol' &&
                    possibleNodes[0].tagName.toLowerCase() !== 'ul') this.$editor().wrapSelection("formatBlock", "default");
                restoreSelection();
            }
        });
        taRegisterTool('insertImage', {
            iconclass: 'fa fa-picture-o',
            tooltiptext: taTranslations.insertImage.tooltip,
            action: function (deferred, restoreSelection) {
                if (taOptions.externalComponent.insertImage) {
                    var self;
                    var savedRange;
                    if (window.getSelection && window.getSelection().rangeCount > 0) {
                        self = window.getSelection();
                        savedRange = window.getSelection().getRangeAt(0).cloneRange();
                    }
                    var _editor = this.$editor();
                    taOptions.externalComponent.insertImage().then(function (embed) {
                        if (self) {
                            self.removeAllRanges();
                            self.addRange(savedRange);
                        }
                        _editor.wrapSelection('insertHTML', embed, true);
                    }).catch(function () { }).finally(function () {
                        deferred.resolve();
                        if (restoreSelection) {
                            restoreSelection();
                        }
                        if (self) {
                            self.removeAllRanges();
                            self.addRange(savedRange);
                        }
                    });
                    return false;
                } else {
                    var imageLink;
                    imageLink = $window.prompt(taTranslations.insertImage.dialogPrompt, 'http://');
                    if (imageLink && imageLink !== '' && imageLink !== 'http://') {
                        var embed = '<img style="max-width:100%" src="' + imageLink + '">';
                        return this.$editor().wrapSelection('insertHTML', embed, true);
                    }
                }
            },
            onElementSelect: {
                element: 'img',
                action: taToolFunctions.imgOnSelectAction
            }
        });
        taRegisterTool('insertVideo', {
            iconclass: 'fa fa-film',
            tooltiptext: taTranslations.insertVideo.tooltip,
            action:
                function (deferred, restoreSelection) {
                    var holder = 'https:// or Embed code';
                    var valuePrompt = $window.prompt(taTranslations.insertVideo.dialogPrompt, holder);
                    if (valuePrompt && valuePrompt !== '' && valuePrompt !== holder) {
                        var self;
                        var savedRange;
                        if (window.getSelection && window.getSelection().rangeCount > 0) {
                            self = window.getSelection();
                            savedRange = window.getSelection().getRangeAt(0).cloneRange();
                        }
                        var _editor = this.$editor();
                        $q.when(taToolFunctions.extractVideo(valuePrompt)).then(function (embed) {
                            if (embed) {
                                // embed = '<img class="' + replacementTags.video.class + '" width="100%"  src="' + video.svg + '" ' + replacementTags.video.attr + '="' + video.embedUrl + '" frameborder="0"  style="background: url(\'' + video.thumbnail + '\'); border-radius:4px;background-size: cover;" />';
                                _editor.wrapSelection('insertHTML', embed, true);
                            }
                        }).finally(function () {
                            deferred.resolve();

                            if (self) {
                                self.removeAllRanges();
                                self.addRange(savedRange);
                            }
                            if (restoreSelection) {
                                restoreSelection();
                            }
                        });

                    }
                    return false;
                },

            onElementSelect: {
                element: 'img',
                onlyWithAttrs: [replacementTags.video.attr],
                action: taToolFunctions.videoOnSelectAction
            }
        });
        taRegisterTool('insertLink', {
            tooltiptext: taTranslations.insertLink.tooltip,
            iconclass: 'fa fa-link',
            action: function () {
                var urlLink;
                urlLink = $window.prompt(taTranslations.insertLink.dialogPrompt, 'http://');
                if (urlLink && urlLink !== '' && urlLink !== 'http://') {
                    return this.$editor().wrapSelection('createLink', urlLink, true);
                }
            },
            activeState: function (commonElement) {
                if (commonElement) return commonElement[0].tagName === 'A';
                return false;
            },
            onElementSelect: {
                element: 'a',
                action: taToolFunctions.aOnSelectAction
            }
        });
        taRegisterTool('wordcount', {
            display: '<div id="toolbarWC" style="display:block; min-width:100px;">Words: <span ng-bind="wordcount"></span></div>',
            disabled: true,
            wordcount: 0,
            activeState: function () { // this fires on keyup
                var textElement = this.$editor().displayElements.text;
                /* istanbul ignore next: will default to '' when undefined */
                var workingHTML = textElement[0].innerHTML || '';
                var noOfWords = 0;

                /* istanbul ignore if: will default to '' when undefined */
                if (workingHTML.replace(/\s*<[^>]*?>\s*/g, '') !== '') {
                    noOfWords = workingHTML.replace(/<\/?(b|i|em|strong|span|u|strikethrough|a|img|small|sub|sup|label)( [^>*?])?>/gi, '') // remove inline tags without adding spaces
                        .replace(/(<[^>]*?>\s*<[^>]*?>)/ig, ' ') // replace adjacent tags with possible space between with a space
                        .replace(/(<[^>]*?>)/ig, '') // remove any singular tags
                        .replace(/\s+/ig, ' ') // condense spacing
                        .match(/\S+/g).length; // count remaining non-space strings
                }

                //Set current scope
                this.wordcount = noOfWords;
                //Set editor scope
                this.$editor().wordcount = noOfWords;

                return false;
            }
        });
        taRegisterTool('charcount', {
            display: '<div id="toolbarCC" style="display:block; min-width:120px;">Characters: <span ng-bind="charcount"></span></div>',
            disabled: true,
            charcount: 0,
            activeState: function () { // this fires on keyup
                var textElement = this.$editor().displayElements.text;
                var sourceText = textElement[0].innerText || textElement[0].textContent; // to cover the non-jquery use case.

                // Caculate number of chars
                var noOfChars = sourceText.replace(/(\r\n|\n|\r)/gm, "").replace(/^\s+/g, ' ').replace(/\s+$/g, ' ').length;
                //Set current scope
                this.charcount = noOfChars;
                //Set editor scope
                this.$editor().charcount = noOfChars;
                return false;
            }
        });
        // wa:
        taRegisterTool('insertTweet', {
            iconclass: 'fa fa-twitter',
            tooltiptext: taTranslations.insertTweet.tooltip,
            action:
                function (deferred, restoreSelection) {
                    var holder = 'https:// or Embed code';
                    var valuePrompt = $window.prompt(taTranslations.insertTweet.dialogPrompt, holder);
                    if (valuePrompt && valuePrompt !== '' && valuePrompt !== holder) {
                        var self;
                        var savedRange;
                        if (window.getSelection && window.getSelection().rangeCount > 0) {
                            self = window.getSelection();
                            savedRange = window.getSelection().getRangeAt(0).cloneRange();
                        }
                        var embed = taToolFunctions.getEmbedForTweetOrIstagram(valuePrompt, replacementTags.twitter);
                        if (!embed) return false;
                        this.$editor().wrapSelection('insertHTML', embed, true);
                        if (self) {
                            self.removeAllRanges();
                            self.addRange(savedRange);
                        }
                        if (restoreSelection) {
                            restoreSelection();
                        }
                    }
                    return false;
                },
            onElementSelect: {
                element: 'img',
                onlyWithAttrs: [replacementTags.twitter.attr],
                action: taToolFunctions.socialMediaOnSelectAction
            }
        });
        taRegisterTool('insertInstagram', {
            iconclass: 'fa fa-instagram',
            tooltiptext: taTranslations.insertInstagram.tooltip,
            action:
                function (deferred, restoreSelection) {
                    var holder = 'https:// or Embed code';
                    var valuePrompt = $window.prompt(taTranslations.insertInstagram.dialogPrompt, holder);
                    if (valuePrompt && valuePrompt !== '' && valuePrompt !== holder) {
                        var self;
                        var savedRange;
                        if (window.getSelection && window.getSelection().rangeCount > 0) {
                            self = window.getSelection();
                            savedRange = window.getSelection().getRangeAt(0).cloneRange();
                        }
                        var embed = taToolFunctions.getEmbedForTweetOrIstagram(valuePrompt, replacementTags.instagram);
                        if (!embed) return false;
                        this.$editor().wrapSelection('insertHTML', embed, true);
                        if (self) {
                            self.removeAllRanges();
                            self.addRange(savedRange);
                        }
                        if (restoreSelection) {
                            restoreSelection();
                        }
                    }
                    return false;
                },
            onElementSelect: {
                element: 'img',
                onlyWithAttrs: [replacementTags.instagram.attr],
                action: taToolFunctions.socialMediaOnSelectAction
            }
        });
        taRegisterTool('insertCarousel', {
            iconclass: 'carousel-icon mb-1 inline-block',
            tooltiptext: taTranslations.insertCarousel.tooltip,
            action:
                function (deferred, restoreSelection) {
                    if (taOptions.externalComponent.carousel) {
                        var self;
                        var savedRange;
                        self = window.getSelection();
                        savedRange = window.getSelection().getRangeAt(0).cloneRange();

                        var _editor = this.$editor();
                        taOptions.externalComponent.carousel().then(function (urls) {
                            if (urls.length == 0) {
                                return;
                            }
                            var images = '';
                            angular.forEach(urls, function (url) {
                                images += '<img src="' + url + '" />';
                            })
                            var embed = '<div class="slick-carousel">' + images + '</div>';
                            var html = taOptions.sanitizeBind.getCarouselHtmlItem(embed);
                            _editor.wrapSelection('insertHTML', html, true);

                        }).catch(function () { }).finally(function () {
                            deferred.resolve();
                            if (restoreSelection) {
                                restoreSelection();
                            }
                            if (self) {
                                self.removeAllRanges();
                                self.addRange(savedRange);
                            }
                        });
                        return false;
                    }
                },
            onElementSelect: {
                element: 'img',
                onlyWithAttrs: [replacementTags.carousel.attr],
                action: taToolFunctions.carouselOnSelectAction
            }
        });
    }]);



//////////////////
// WEBPACK FOOTER
// ./src/assets/js/vendor/textAngular/textAngularSetup.js
// module id = 2056
// module chunks = 6